import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return ({
		searchBar: {
			backgroundColor: "white",
			borderRadius: 4,
			padding: "5px 20px",
		},
	} satisfies Record<string, CSSObject>);
}